import ScrollToTop from '../components/ScrollToTop'
import Contact from '../components/Contact'

function ContactPage() {
  return (
    <>
      <ScrollToTop />
      <Contact />
    </>
  )
}

export default ContactPage